export default __webpack_public_path__ + "static/media/library-crud-application.41b3f69b.png";